import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, crudDeleteMany } from 'react-admin';
import Delete from '@material-ui/icons/Delete';

class BulkDeleteButton extends Component {
    state = {
        isOpen: false,
    }

    handleClick = () => {
        this.setState({ isOpen: true });
    };

    handleConfirm = () => {
        const { basePath, crudDeleteMany, resource, selectedIds } = this.props;
        crudDeleteMany(resource, selectedIds, basePath);
    };

    handleDialogClose = () => {
        this.setState({ isOpen: false });
    };

    getRealId = id => {
        return new Buffer(id, 'base64').toString('utf-8');
    }

    render() {
        return (
            <Fragment>
                <Button label="Delete" onClick={this.handleClick} color="secondary">
                    <Delete />
                </Button>
                <Confirm
                    isOpen={this.state.isOpen}
                    title="Bulk Delete"
                    content={<div>
                                Are you sure you want to delete these {this.props.selectedIds.length} items?<br /><br />
                                {this.props.selectedIds.map(id => <div>{this.props.encoded ? this.getRealId(id) : id}</div>)}
                            </div>}
                    onConfirm={this.handleConfirm}
                    onClose={this.handleDialogClose}
                />
            </Fragment>
        );
    }
}

export default connect(undefined, { crudDeleteMany })(BulkDeleteButton);


// WEBPACK FOOTER //
// ./src/resources/ui/BulkDeleteButton.js